module.exports = __webpack_public_path__ + "img/google-plus.9784650d.svg";